import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayTrainTypeName'
})
export class DisplayTrainTypeNamePipe implements PipeTransform {

  transform(trainTypeCode: string, customTrainTypeNames: {
    code: string,
    displayName: string
  }[]): string {
    const customTrainType = customTrainTypeNames && customTrainTypeNames[trainTypeCode];
    return customTrainType ? customTrainType.displayName : trainTypeCode
  }

}
